module.exports = __webpack_public_path__ + "img/wide.86b09ddb.jpg";